const $$splitComponentImporter = () => import('/app/src/routes/dashboard/client/group-therapies.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/client/group-therapies")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});